import isEmpty from "lodash-es/isEmpty";
import { Button, PlusIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Key } from "antd/lib/table/interface";
import { EfsMelcoModelsUserAlphabet } from "melco-shared-logic";
import { useAddFonts } from "../../../hooks/libraries/fontCollections/useAddFonts";

type BulkActionAddFontsProps = {
  allFonts: EfsMelcoModelsUserAlphabet[];
  selectedRowKeys: Key[];
  setSelectedRowKeys: (keys: Key[]) => void;
};

export const BulkActionAddFonts: React.FC<BulkActionAddFontsProps> = ({
  allFonts,
  selectedRowKeys,
  setSelectedRowKeys,
}) => {
  const { t } = useTranslation();

  const { addFonts } = useAddFonts();

  if (isEmpty(selectedRowKeys)) {
    return null;
  }

  return (
    <Button
      key="bulk-add-selected"
      icon={<PlusIcon />}
      onClick={() => {
        const fontsToAdd = allFonts.filter((f) =>
          selectedRowKeys.includes(f.id!)
        );

        addFonts(fontsToAdd);

        setSelectedRowKeys([]);
      }}
    >
      {t("font_collections.actions.add_fonts.actions.add_selected")}
    </Button>
  );
};
